import { Injectable } from '@angular/core';

export enum AdSizes {
  LARGE_RECTANGLE = 'large-rectangle', // 336x280
  MEDIUM_RECTANGLE = 'medium-rectangle', // 300x250
  LEADERBOARD = 'leaderboard', // 728x90
  LARGE_MOBILE = 'large-mobile', // 320x100
  SKYSCRAPER = 'skyscraper', // 300x600
}

export enum AdPositions {
  SIDEBAR_TOP = 'sidebar-top',
  SIDEBAR_BOTTOM = 'sidebar-bottom',
  CONTENT_TOP = 'content-top',
  CONTENT_BOTTOM = 'content-bottom',
  RIGHT_RAIL = 'right-rail',
}

export interface AdConfig {
  position: AdPositions;
  size: AdSizes;
  enabled: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class AdService {
  // Mock configuration for ads - in a real app, this might come from a config server
  private adConfigs: Record<AdPositions, AdConfig> = {
    [AdPositions.SIDEBAR_TOP]: {
      position: AdPositions.SIDEBAR_TOP,
      size: AdSizes.MEDIUM_RECTANGLE,
      enabled: true,
    },
    [AdPositions.SIDEBAR_BOTTOM]: {
      position: AdPositions.SIDEBAR_BOTTOM,
      size: AdSizes.SKYSCRAPER,
      enabled: true,
    },
    [AdPositions.CONTENT_TOP]: {
      position: AdPositions.CONTENT_TOP,
      size: AdSizes.LEADERBOARD,
      enabled: false,
    },
    [AdPositions.CONTENT_BOTTOM]: {
      position: AdPositions.CONTENT_BOTTOM,
      size: AdSizes.LEADERBOARD,
      enabled: false,
    },
    [AdPositions.RIGHT_RAIL]: {
      position: AdPositions.RIGHT_RAIL,
      size: AdSizes.SKYSCRAPER,
      enabled: true,
    },
  };

  constructor() {}

  /**
   * Get ad configuration for a specific position
   */
  getAdConfig(position: AdPositions): AdConfig {
    return this.adConfigs[position];
  }

  /**
   * Check if an ad at a specific position is enabled
   */
  isAdEnabled(position: AdPositions): boolean {
    return this.adConfigs[position]?.enabled || false;
  }

  /**
   * Update the configuration for an ad position
   */
  updateAdConfig(position: AdPositions, config: Partial<AdConfig>): void {
    if (this.adConfigs[position]) {
      this.adConfigs[position] = {
        ...this.adConfigs[position],
        ...config,
      };
    }
  }

  /**
   * Enable all ads
   */
  enableAllAds(): void {
    Object.keys(this.adConfigs).forEach(position => {
      this.adConfigs[position as AdPositions].enabled = true;
    });
  }

  /**
   * Disable all ads
   */
  disableAllAds(): void {
    Object.keys(this.adConfigs).forEach(position => {
      this.adConfigs[position as AdPositions].enabled = false;
    });
  }
}
